import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {COMPONENTS, COMPONENTS_EXPORTS, SERVICES} from './index';
import {CoreModule} from '../../core/core.module';
import {notificationReducer} from "@ispm/dashboard/notification/store/notification.reducer";

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    StoreModule.forFeature('notification', notificationReducer)
  ],
  declarations: [...COMPONENTS],
  providers: [...SERVICES],
  exports: [...COMPONENTS_EXPORTS]
})
export class NotificationModule {
}
